export const RESET = 'EXCMTEAMUSERDATA_UPDATE_RESET'
export const SET_ERROR = 'EXCMTEAMUSERDATA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMTEAMUSERDATA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMTEAMUSERDATA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMTEAMUSERDATA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMTEAMUSERDATA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMTEAMUSERDATA_UPDATE_UPDATE_RETRIEVED'
